// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3ff04b28] .filter-manager_extended {\n  border-radius: 0.25rem;\n}\n@media only screen and (min-width: 750px) {\n[data-v-3ff04b28] .filter-manager_extended .search-btn.col-lg-3 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 10%;\n            flex: 0 0 10%;\n    max-width: 10%;\n    padding-left: 0;\n}\n}", ""]);
// Exports
module.exports = exports;
